import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { ProvedorAutenticacao } from './lib/auth';
import AvisoAtualizacao from './componentes/AvisoAtualizacao';
import './index.css';

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado no index.html');

createRoot(raiz).render(
  <React.StrictMode>
    <BrowserRouter>
      <ProvedorAutenticacao>
        <App />
        <AvisoAtualizacao />
      </ProvedorAutenticacao>
    </BrowserRouter>
  </React.StrictMode>,
);
